import React, { useEffect, useState, useRef } from "react";
import Layout from "../../../components/towerHeadAdmin/Layout";
import Helmet from "react-helmet";
import Table from "../../../components/ui/Table";
import Pagination from "../../../components/ui/Pagination";
import SelectField from "../../../components/ui/form/SelectField";
import InputField from "../../../components/ui/form/InputField";
import usePaginate from "../../../hooks/api/usePaginate";
import { useSelector } from "react-redux";
import apiRequest from "../../../utils/towerHeadAdmin/apiRequest";
import { Link } from "react-router-dom";
import { PRODUCT_BY_EXCEL } from "../../../routes/towerHeadAdmin/towerHeadAdminRoutes";
import AsyncSearchSelect from "../../../components/ui/form/AsyncSearchSelect";
import { FaCheck } from "react-icons/fa";

const MenuPricing = () => {
  const [search, setSearch] = useState("");
  const [filters, setFilters] = useState({});
  const [vendorManagerId, setVendorManagerId] = useState("");

  const debounceRef = useRef(null);

  const {
    data: imports,
    setFilters: setImportFilters,
    setPage,
    limit,
    currentPage,
    fetchData,
    error,
    loading,
    totalPages,
    totalItems,
  } = usePaginate({
    apiMethod: apiRequest.getExcelImportList,
    dataKey: "imports",
  });


  useEffect(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current);

    debounceRef.current = setTimeout(() => {
      setFilters((prev) => {
        const newFilters = { ...prev };

        if (search.trim()) {
          newFilters.excelName = { $regex: search.trim(), $options: "i" };
        } else {
          delete newFilters.excelName;
        }

        if (vendorManagerId) {
          newFilters.vendorManagerId = vendorManagerId;
        } else {
          delete newFilters.vendorManagerId;
        }

        setImportFilters(newFilters);
        return newFilters;
      });
    }, 300);

    return () => clearTimeout(debounceRef.current);
  }, [search, vendorManagerId, setImportFilters]);

  const fetchVendors = async (search) => {
    const res = await apiRequest.getVendorManagerForSelect({
      body: {
        filters: { name: { $regex: search, $options: "i" } },
        paginate: false,
      },
    });

    return (
      res?.data?.data?.vendors?.map((v) => ({
        label: v.label,
        value: v.value,
      })) || []
    );
  };

  const handleVendorChange = (value) => {
    setVendorManagerId(value);
  };

  return (
    <Layout>
      <Helmet>
        <title>Excel Imports</title>
      </Helmet>

      <div className="p-4 bg-white rounded">
     

        <div className="grid my-2 grid-cols-1 sm:grid-cols-3 gap-2 mb-3">
          <InputField
            placeholder="Search by excel name..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <AsyncSearchSelect

            value={vendorManagerId}
            onChange={handleVendorChange}
            fetchOptions={fetchVendors}
            placeholder="Search Vendor Manager"
          />

          <button
            className="py-1 text-white rounded bg-emerald-600 hover:bg-emerald-800"
            onClick={() => {
              setSearch("");
              setVendorManagerId("");
              setImportFilters({});
            }}
          >
            Clear
          </button>


        </div>

        <Table
          headers={[
            { label: "Excel Name", key: "excelName" },
            { label: "Vendor Manager", key: "vendormanager" },
            { label: "Inserted", key: "inserted" },
            { label: "Updated", key: "updated" },
            { label: "Created", key: "createdAt" },
            { label: "Action" },
          ]}
          loading={loading}
          cols={5}
          error={error}
          renderRow={
            <tbody className="bg-white divide-y divide-gray-200">
              {(imports || []).map((imp) => (
                <tr key={imp._id} className="hover:bg-gray-50">
                  <td className="px-3 py-3">{imp.excelName}</td>
                  <td className="px-3 py-3 capitalize">{imp?.vendorManagerId?.name}</td>
                  <td className="px-3 py-3">{imp.inserted}</td>
                  <td className="px-3 py-3">{imp.updated}</td>
                  <td className="px-3 py-3">{new Date(imp.createdAt).toLocaleDateString()}</td>
                  <td className="px-3 flex gap-2 items-center py-3">

                    <button

                      className="text-green-500"
                      title="assign"
                    >
                      <FaCheck size={18} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          }
        />

        {totalPages > 1 && (
          <Pagination
            pagination={{ currentPage, totalPages, totalItems, perPage: limit }}
            handlePageChange={setPage}
            loading={loading}
          />
        )}
      </div>
    </Layout>
  );
};

export default MenuPricing;
